import { msg } from '@lingui/core/macro'
import { useLingui } from '@lingui/react'
import { formatDateTime } from '../../../helpers/timesheet'

/** End time, or the pending clock-out notice (v1). */
export const ClockOutPendingLabel = ({
  endTime,
  className,
}: {
  endTime?: string | null
  className: string
}) => {
  const { _ } = useLingui()
  return (
    <span className={`${className} ${endTime ? '' : `${className}--pending`}`}>
      {endTime ? formatDateTime(endTime) : _(msg`Pending clock out`)}
    </span>
  )
}
